(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('afandi-review-wall')) {
    class ReviewWall extends HTMLElement {
      connectedCallback() {
        this.readyObserver?.disconnect();
        if (this.querySelector('[data-rw-ready]')) {
          this.initialize();
          return;
        }
        this.readyObserver = new MutationObserver(() => {
          if (!this.isConnected || !this.querySelector('[data-rw-ready]')) return;
          this.readyObserver.disconnect();
          this.initialize();
        });
        this.readyObserver.observe(this, { childList: true });
      }

      initialize() {
        this.stopMasonry();
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.strip = this.querySelector('[data-rw-strip]');
        this.modal = this.querySelector('[data-rw-modal]');
        this.slides = Array.from(this.querySelectorAll('[data-rw-slide]'));
        this.status = this.querySelector('[data-rw-status]');
        this.current = 0;
        this.opener = null;
        this.setupMasonry(signal);

        this.addEventListener('click', (event) => {
          const button = event.target.closest?.('button');
          if (!button) {
            const card = event.target.closest?.('.rw__card--photo');
            if (!card || !this.contains(card) || window.getSelection?.()?.toString()) return;
            const trigger = card.querySelector('[data-rw-open]');
            if (trigger) this.open(trigger.dataset.rwOpen, trigger);
            return;
          }
          if (!this.contains(button)) return;

          if (button.hasAttribute('data-rw-scroll') && this.strip) {
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.strip.scrollBy({
              left: Number(button.dataset.rwScroll) * this.strip.clientWidth * 0.8,
              behavior: reducedMotion ? 'auto' : 'smooth'
            });
          } else if (button.hasAttribute('data-rw-open')) {
            this.open(button.dataset.rwOpen, button);
          } else if (button.hasAttribute('data-rw-step')) {
            this.show(this.current + Number(button.dataset.rwStep));
          } else if (button.hasAttribute('data-rw-close')) {
            this.modal?.close();
          }
        }, { signal });

        this.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail?.blockId;
          const index = this.slides.findIndex((slide) => slide.dataset.rwSlide === blockId);
          if (this.modal?.open && index >= 0) {
            this.show(index);
            return;
          }
          if (this.modal?.open) this.modal.close();
          const elements = Array.from(this.querySelectorAll('[data-rw-review]'));
          const card = elements.find((element) => element.dataset.rwReview === blockId && element.classList.contains('rw__card'));
          const tile = elements.find((element) => element.dataset.rwReview === blockId && element.classList.contains('rw__tile'));
          (card || tile)?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }, { signal });

        if (!this.modal) return;
        this.modal.addEventListener('click', (event) => {
          if (event.target !== this.modal) return;
          const rect = this.modal.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
            this.modal.close();
          }
        }, { signal });
        this.modal.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.modal.close();
            return;
          }
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        this.modal.addEventListener('close', () => {
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
          this.opener = null;
        }, { signal });
      }

      disconnectedCallback() {
        this.readyObserver?.disconnect();
        this.stopMasonry();
        this.controller?.abort();
        if (this.modal?.open) this.modal.close();
        this.opener = null;
      }

      setupMasonry(signal) {
        this.grid = this.querySelector('[data-rw-grid]');
        this.cards = this.grid ? Array.from(this.grid.querySelectorAll('.rw__card')) : [];
        if (!this.grid || !this.cards.length) return;

        const schedule = () => {
          if (signal.aborted || this.masonryFrame != null) return;
          this.masonryFrame = window.requestAnimationFrame(() => {
            this.masonryFrame = null;
            if (this.isConnected && !signal.aborted) this.layoutMasonry();
          });
        };

        if ('ResizeObserver' in window) {
          this.masonryObserver = new ResizeObserver(schedule);
          this.masonryObserver.observe(this.grid);
          this.cards.forEach((card) => this.masonryObserver.observe(card));
        }
        this.grid.addEventListener('load', schedule, { capture: true, signal });
        window.addEventListener('resize', schedule, { signal });
        document.fonts?.ready.then(schedule);
        schedule();
      }

      layoutMasonry() {
        if (!this.grid.getClientRects().length) return;
        const gridStyle = window.getComputedStyle(this.grid);
        const columns = Math.max(1, Math.min(4, parseInt(gridStyle.getPropertyValue('--rw-layout-cols'), 10) || 1));
        const gap = parseFloat(gridStyle.columnGap) || 0;
        const width = parseFloat(gridStyle.width);
        if (!Number.isFinite(width) || width <= 0) return;
        const cardWidth = (width - gap * (columns - 1)) / columns;
        if (cardWidth <= 0) return;

        this.cards.forEach((card) => {
          card.style.setProperty('--rw-masonry-width', `${cardWidth}px`);
        });
        // Used CSS heights are not distorted by a scaled theme-editor preview.
        // All widths are written before reading heights; positions are written afterward.
        const heights = this.cards.map((card) => Math.ceil(parseFloat(window.getComputedStyle(card).height) || card.offsetHeight));
        const columnHeights = Array(columns).fill(0);
        this.cards.forEach((card, index) => {
          const column = columnHeights.indexOf(Math.min(...columnHeights));
          card.style.setProperty('--rw-masonry-x', `${column * (cardWidth + gap)}px`);
          card.style.setProperty('--rw-masonry-y', `${columnHeights[column]}px`);
          columnHeights[column] += heights[index] + gap;
        });
        this.grid.style.setProperty('--rw-masonry-height', `${Math.max(0, Math.max(...columnHeights) - gap)}px`);
        this.grid.setAttribute('data-rw-masonry', '');
      }

      stopMasonry() {
        this.masonryObserver?.disconnect();
        this.masonryObserver = null;
        if (this.masonryFrame != null) window.cancelAnimationFrame(this.masonryFrame);
        this.masonryFrame = null;
      }

      open(blockId, trigger) {
        if (!this.modal || !this.slides.length) return;
        const index = this.slides.findIndex((slide) => slide.dataset.rwSlide === blockId);
        if (index < 0) return;
        this.opener = trigger;
        this.show(index);
        if (!this.modal.open) this.modal.showModal();
      }

      show(index) {
        const count = this.slides.length;
        if (!count) return;
        this.current = ((index % count) + count) % count;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.current; });
        if (this.status) this.status.textContent = `Review ${this.current + 1} of ${count}`;
        if (this.modal) this.modal.scrollTop = 0;
      }
    }
    customElements.define('afandi-review-wall', ReviewWall);
  }

  } catch(e) { console.error(e); }
})();
})();
